<template>
  <header class="site-hero">
    <div class="hero-media">
      <img
        class="hero-img hero-desktop d-none d-md-block"
        :src="$t('Header.HeroDesktop')"
        alt="Dr Pepper Laval promotion"
      />
      <img
        class="hero-img hero-mobile d-md-none"
        :src="$t('Header.HeroMobile')"
        alt="Dr Pepper Laval promotion"
      />

      <nav v-if="!$route.meta.hideNav" class="hero-nav" aria-label="Primary navigation">
        <router-link to="/Home">{{ $t('Header.HomeTab') }}</router-link>
        <router-link to="/Support">{{ $t('Header.SupportTab') }}</router-link>
        <button @click="changeLanguage('en')" :class="{ active: currentLang === 'en' }">EN</button>
        <button @click="changeLanguage('fr')" :class="{ active: currentLang === 'fr' }">FR</button>
      </nav>
    </div>
    <!-- <div class="hero-divider" aria-hidden="true"></div> -->
  </header>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { loadLocaleMessages } from '@/main.js';

export default {
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    // Get the current route object
    const route = useRoute();

    // Create a computed property to check if the current path is '/Home'
    const isHomePage = computed(() => route.path === '/Home');

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const closeMenu = () => {
      isCollapsed.value = false;
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      const hostname = window.location.hostname;
      const isLocal = hostname === "localhost";
      const isStaging = hostname.includes("staging");

      if (isLocal) {
        // Local: Change language dynamically
        await loadLocaleMessages(lang);
        locale.value = lang;
        localStorage.setItem("locale", lang);
        currentLang.value = lang;
        injectGTM();
      } else {
        // Staging & Production: Redirect to language-specific domains
        const currentPath = window.location.pathname;
        const currentQuery = window.location.search;

        const langBaseUrls = {
          en: isStaging ? "https://staging-drpeppertuitionprogram.snipp.us/National" : "https://drpeppertuitionprogram.ca/National",
          fr: isStaging ? "https://staging-prixetudiantsdrpepper.snipp.us/National" : "https://prixetudiantsdrpepper.ca/National",
        };

        const targetBase = langBaseUrls[lang] || "/";
        const targetUrl = `${targetBase}${currentPath}${currentQuery}`;

        window.location.href = targetUrl;
      }
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    return { currentLang, changeLanguage, isCollapsed, toggleCollapse, closeMenu, isHomePage };
  },
};
</script>
